<template>
  <div>
     <div style="padding-top:10px;margin-left:20px;margin-right:20px;">
     
      <v-carousel>
        <v-carousel-item
          v-for="(item,i) in items"
          :key="i"
          :src="item.src"
          reverse-transition="fade-transition"
          transition="fade-transition"
        ></v-carousel-item>
      </v-carousel>
    </div>
    <v-card-title class="down pop">
      <b>Products</b>
    </v-card-title>

    <!-- <br> -->
    <v-flex>
      <v-row style="margin-left:20px;margin-right:20px;">
        <v-col md="3" v-for="i in data">
          <v-card style="margin:8px;" height="100%">
            <div style="padding-top:0px;">
              <!-- <v-img style="margin:10px;"
            height="100"
            width="300"
            src="https://cdn.vuetifyjs.com/images/cards/store.jpg"
              ></v-img>-->
              <v-img :src="'https://api.inguzsales.in/u/' +i.photos[0]" height="200" width="auto" />
            </div>
            <!-- <v-img :src="'https://picsum.photos/300/300?random=1'+i.photo1" /> -->
            <v-card-title primary-title></v-card-title>
            <v-card-text>
              <div>
                <span style="font-size:20px;font-weight:500;color:black;">
                  <strong  class="prfont">{{i.productname}}</strong>
                </span>
                <star-rating style=""
                  v-bind:increment="1"
                  v-bind:star-size="14"
                  active-color="#ff4e00"
                  :read-only="true"
                  v-bind:rating="Math.floor(Math.random() * (5 - 1) + 1)"
                  required
                ></star-rating>
              </div>
              <v-flex md12>
                <v-row>
                  <v-col>
                    <span style="font-size:20px;color:black;">
                      <strong>₹{{i.price}}</strong>
                    </span>
                  </v-col>
                  <v-col>
                    <div v-if="i.instock"  class="prfont" >(In Stock)</div>
                    <div v-else  class="prfont">(Out of Stock)</div>
                  </v-col>
                </v-row>
              </v-flex>
               <span style="font-size:15px;font-weight:300;color:black;">
                <span style="text-align:justify;" class="prfont"><p>{{i.description.slice(0,30)}}..</p></span>
                <!-- <br /> -->
              </span>
                <!-- <br /> -->
            
           
                
             
              <!-- <br /> -->

              <v-flex md12>
                <router-link :to="'/Product/' +i.productname">
                      <v-btn  color="#ff4e00" dark block>Details</v-btn>
                    </router-link>
                <v-row>
                  <v-col align="center">
                    
                  </v-col>
                </v-row>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-flex>
    <div style="margin-left:40px;margin-right:40px;">
      <v-row>
        <v-col md="4">
          <img src="../../assets/of1.png" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/ofr.png" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/rel.jpg" style="width:100%; height:auto;" />
        </v-col>
      </v-row>
    </div>
    <div>
      <v-card-title class="down pop">
        <b>Popular Products</b>
      </v-card-title>
      <v-flex>
      <v-row style="margin-left:20px;margin-right:20px;">
        <v-col md="3" v-for="i in data">
          <v-card style="margin:8px;">
            <div style="padding-top:0px;">
              <!-- <v-img style="margin:10px;"
            height="100"
            width="300"
            src="https://cdn.vuetifyjs.com/images/cards/store.jpg"
              ></v-img>-->
              <v-img :src="'https://api.inguzsales.in/u/' +i.photos[0]" height="156" width="auto" />
            </div>
            <!-- <v-img :src="'https://picsum.photos/300/300?random=1'+i.photo1" /> -->
            <v-card-title primary-title></v-card-title>
            <v-card-text>
              <div>
                <span style="font-size:20px;font-weight:500;color:black;">
                  <strong  class="prfont">{{i.productname}}</strong>
                </span>
                <star-rating style=""
                  v-bind:increment="1"
                  v-bind:star-size="14"
                  active-color="#ff4e00"
                  :read-only="true"
                  v-bind:rating="Math.floor(Math.random() * (5 - 1) + 1)"
                  required
                ></star-rating>
              </div>
              <v-flex md12>
                <v-row>
                  <v-col>
                    <span style="font-size:20px;color:black;">
                      <strong>₹{{i.price}}</strong>
                    </span>
                  </v-col>
                  <v-col>
                    <div v-if="i.instock"  class="prfont" >(In Stock)</div>
                    <div v-else  class="prfont">(Out of Stock)</div>
                  </v-col>
                </v-row>
              </v-flex>
               <span style="font-size:15px;font-weight:300;color:black;">
                <span style="text-align:justify;" class="prfont"><p>{{i.description.slice(0,30)}}..</p></span>
                <!-- <br /> -->
              </span>
                <!-- <br /> -->
            
           
                
             
              <!-- <br /> -->

              <v-flex md12>
                <router-link :to="'/Product/' +i.productname">
                      <v-btn  color="#ff4e00" dark block>Details</v-btn>
                    </router-link>
                <v-row>
                  <v-col align="center">
                    
                  </v-col>
                </v-row>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-flex>
      <!-- <hr /> -->
      <!-- <br> -->
      <!-- <v-flex>
        <v-row style="margin-left:20px;margin-right:20px;">
          <v-col v-for="product in 5">
            <v-card style="margin:8px;">
              <div style="padding-top:5px;">
               
                <v-card-title primary-title></v-card-title>
                <v-img
                  style="margin:10px;"
                  height="100"
                  width="200"
                  src="https://cdn.vuetifyjs.com/images/cards/store.jpg"
                ></v-img>
              </div>
              <v-card-text>
                <div>
                  <span style="font-size:16px;color:black;">
                    <strong>Product {{product}}</strong>
                  </span>
                  <hr />
                </div>
                <v-flex md12>
                  <v-row>
                    <v-col>
                      <span style="font-size:20px;color:black;">
                        <strong>₹{{product}}</strong>
                      </span>
                    </v-col>
                    <v-col>
                      <star-rating
                        v-bind:increment="1"
                        v-bind:star-size="20"
                        active-color="#0e4e35"
                        :read-only="true"
                        v-bind:rating="Math.floor(Math.random() * (5 - 1) + 1)"
                        required
                      ></star-rating>
                    </v-col>
                  </v-row>
                </v-flex>
                <span style="font-size:14px;color:black;">
                  <span>Description of Product {{product}}</span>
                
                </span>
             
                <div v-if="product.instock">(In Stock)</div>
                <div v-else>(Out of Stock)</div>
                <v-flex md12>
                  <v-row>
                    <v-col align="center">
                      <router-link :to="'/Product/'+product+'5d83448c706d332704590afc'">
                        <v-btn text color="#0e4e35" dark small>Details</v-btn>
                      </router-link>
                    </v-col>
                  </v-row>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-flex> -->
    </div>
    <div style="margin-left:40px;margin-right:40px;">
      <v-row>
        <v-col md="4">
          <img src="../../assets/ph.png" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/me.jpg" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/rel.jpg" style="width:100%; height:auto;" />
        </v-col>
      </v-row>
    </div>
    <br />
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import store from '../../store'
import axios from "axios";
import AppSideNav from "@/components/common/AppSideNav";

export default {
  props: ["id"],
  components: {
    AppSideNav,
    StarRating
  },
  data() {
    return {
         items: [
        {
          src:
            "https://cdn.static-zoutons.com/images/originals/stores/Nykaa_App_1568270141.jpg"
        },
        {
          src:
            "https://cdn.static-zoutons.com/images/originals/stores/Flipkart_App_1569412752.jpg"
        },
        {
          src:
            "https://www.nokiacamp.com/wp-content/uploads/2018/10/Nokia-offer.jpg"
        },
        {
          src:
            "https://opt.toiimg.com/recuperator/img/toi/m-73692781/73692781.jpg?resizemode=1&width=215&height=145"
        }
      ],
      avg:"",
      did:"",
      data: [],
      product: {
        name: null,
        price: null,
        desc: null,
        instock: null,
        seller: null,
        id: null,
        status: null
      }
    };
  },
   mounted: function() {
   
    this.getReview();
    
  },
  beforeMount() {
    this.getproducts();
    this.getproduct();
  },
  methods: {
       getReview() {
      axios({
        method: "GET",
        url: "/review/productwise?productid=" + this.did
      }).then(Response => {
        // console.log(Response);
        this.review = Response.data.data;
        this.comment = Response.data.data.comment;
        this.rating = Response.data.data.rating;
        this.onestarcount=Response.data.onestarcount;
        this.twostarcount=Response.data.twostarcount;
         this.threestarcount=Response.data.threestarcount;
          this.fourstarcount=Response.data.fourstarcount;
           this.fivestarcount=Response.data.fivestarcount;
           this.count=Response.data.count;
           this.avg=Response.data.avg;

      });
    },
    getproducts() {
      axios({
        method: "GET",
        url: "/product/all/"
      }).then(Response => {
        this.data = Response.data.data;
       
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.data.length; i++) {
           
            var tyid = this.data[i]._id;
            // temp.push(ty);
            tempid.push(tyid);
          }
          
          this.did = tempid;
          this.visible = false;
        
        this.photos = Response.data.data.photos;

        var tempflag = [];
        for (var i = 0; i < this.photos.length; i++) {
          var tyimg = {
            src: "https://api.inguzsales.in/u/" + this.photos[i],
            // src: $Image_URL + this.regions[i].flag,
            id: this.photos[i]
          };
          tempflag.push(tyimg);
        }
        this.dataImages = tempflag;
      });
    },
    getproduct() {
      axios({
        method: "GET",
        url: "/product/info?id=" + this.id
      }).then(Response => {
        // console.log(Response);
        var prodata = Response.data.data;
        this.product.name = prodata.productname;
        this.product.price = prodata.price;
        this.product.desc = prodata.description;
        this.product.instock = prodata.instock;
        this.product.seller = prodata.seller;
        this.product.id = prodata._id;
        this.product.status = prodata.status;
      });
    }
  }
};
</script><style scoped>
.prfont {
  font-family: "Montserrat";
}
</style>